/** @file Inverts a 2x3 affine, refusing a singular one with VALIDATION at a caller-given path. */
import { affine } from '@pose2d/math/affine';
import type { Affine } from '@pose2d/math/types';
import { throwError } from '@pose2d/format/throwError';

/** Smallest |determinant| treated as invertible (a zero setup scale gives exactly 0). */
const MIN_DET = 1e-12;

/** A new Float64Array holding m⁻¹; VALIDATION at `path` with `hint` when |det m| < 1e-12 or is NaN. */
export function invertChecked(m: Affine, path: string, hint: string): Float64Array {
  const det = (m[0] ?? 0) * (m[3] ?? 0) - (m[1] ?? 0) * (m[2] ?? 0);
  if (!(Math.abs(det) >= MIN_DET)) throwError('VALIDATION', undefined, { path, hint });
  const out = new Float64Array(6);
  affine.invert(out, m);
  return out;
}
